export enum ApprovalType {
  PendingCorrection = 0,
  PendingInternalTransfer = 1,
  PendingNav = 2,
  PendingMessage = 3,
  PendingIban = 4,
  PendingYieldu = 5,
  PendingCompositionVersion = 6,
  PendingFund = 7,
  PendingDividend = 8,
  PendingGfhAccountCreation = 9,
  PendingAccountCostChange = 10,
  PendingRebalance = 11,
}
